import moment from 'moment';

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function updateDataByType({ cell }) {
  switch (cell.type) {
    case 'select': {
      return cell.selectedValue;
    }
    case 'checkbox': {
      return cell.checked;
    }
    case 'customText': {
      return cell.text;
    }
    case 'customNumber': {
      return cell.value;
    }
    case 'customBoolean': {
      return cell.selectedValue === 'Yes' ? true : cell.selectedValue === 'No' ? false : null;
    }
    case 'customDate': {
      return isValidDate(cell.date) ? moment(cell.date).format('YYYY-MM-DD') : null;
    }
    case 'customDateTime': {
      return isValidDate(cell.date) ? cell.date : null;
    }
  }
}

export const getDefaultValueByType = value => {
  if (value.type.includes('string') && value.format === 'date') {
    return null;
  }

  if (value.type.includes('string')) {
    return '';
  }
  if (value.type.includes('integer') || value.type.includes('number')) {
    return null;
  }

  if (value.type.includes('boolean')) {
    return null;
  }

  if (value.type.includes('array')) {
    return '';
  }
};

export const getTypeFromSchema = value => {
  if (value.type.includes('array')) {
    return 'select';
  }

  if (value.type.includes('string') && value.format === 'date') {
    return 'customDate';
  }

  if (value.type.includes('string') && value.format === 'date-time') {
    return 'customDateTime';
  }

  if (value.type.includes('date')) {
    return 'customDate';
  }

  if (value.type.includes('string')) {
    return 'customText';
  }
  if (value.type.includes('integer') || value.type.includes('number')) {
    return 'customNumber';
  }

  if (value.type.includes('boolean')) {
    return 'customBoolean';
  }
};

export const getKeyByType = type => {
  if (type === 'select') {
    return 'selectedValue';
  }

  if (type === 'customText') {
    return 'text';
  }
  if (type === 'customNumber') {
    return 'value';
  }

  if (type === 'customBoolean') {
    return 'selectedValue';
  }

  if (type === 'customDate') {
    return 'date';
  }

  if (type === 'customDateTime') {
    return 'date';
  }
};

export const filterArrayByFieldsWithStop = (array, fields) => {
  const result = [];

  for (const obj of array) {
    if (
      fields
        .filter(field => field !== 'ranking')
        .some(
          field =>
            obj[field] !== '' &&
            obj[field] !== null &&
            obj[field] !== undefined &&
            !Number.isNaN(obj[field])
        )
    ) {
      result.push(obj);
    } else if (obj.id && fields.includes('ranking')) {
      result.push({
        ...obj,
        is_deleted: true
      });
    } else if (obj.id) {
      result.push(obj);
    }
  }

  return result;
};

export const filterArrayByFieldsNotEmptyValue = (array, fields) => {
  const result = [];

  for (const obj of array) {
    if (
      fields
        .filter(field => field !== 'ranking')
        .some(
          field =>
            obj[field] !== '' &&
            obj[field] !== null &&
            obj[field] !== undefined &&
            !Number.isNaN(obj[field])
        )
    ) {
      result.push(obj);
    } else if (obj.id) {
      result.push({
        ...obj,
        is_deleted: true
      });
    }
  }

  return result;
};

export const filterArrayByFieldsForMultipleTable = (array, fields) => {
  const result = [];

  for (const obj of array) {
    if (
      fields.some(
        field =>
          obj[field] !== '' &&
          obj[field] !== null &&
          obj[field] !== undefined &&
          !Number.isNaN(obj[field])
      )
    ) {
      result.push(obj);
    } else if (obj.id) {
      result.push({
        ...obj,
        is_deleted: true
      });
    } else {
      result.push(obj);
    }
  }

  return result;
};
